<template>
  <div class="exchange">
    <div class="header">
      <van-grid :border="true" :column-num="2">
        <van-grid-item
          @click="switchTab(1)"
          :class="{ active: switchTabIndex == 1 }"
        >
          <span>{{ $t("exchangePage.duihuan") }}</span>
        </van-grid-item>
        <van-grid-item
          @click="switchTab(2)"
          :class="{ active: switchTabIndex == 2 }"
        >
          <span>{{ $t("exchangePage.jilu") }}</span>
        </van-grid-item>
      </van-grid>
    </div>
    <div v-if="switchTabIndex == 1" style="height: 100%">
      <div v-if="showLoading1" class="loading-stat">
        <van-loading size="35" />
      </div>
      <div class="body" v-else>
        <div
          class="card"
          v-for="(item, index) of list"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="img__wrap">
            <img :src="item.thumbImageUrl" alt="" class="cardImg" />
            <div class="mengban">
              <div class="jpName">{{ item.name }}</div>
              <div class="money">
                <van-image width="15" max-height="15" :src="jinbi" /> 
                <div>{{ item.displayPoints }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="finished-text" v-show="list.length" style="margin: 20px">
          <div class="finished-text__line"></div>
          <span class="finished-text__text">{{ $t("baseline") }}</span>
        </div>
        <div class="loading-stat" v-show="list.length === 0">
          <van-image width="100" height="100" :src="img" />
        </div>
      </div>
    </div>
    <div class="body record" v-if="switchTabIndex == 2" style="height: 100%">
      <div v-if="showLoading1" class="loading-stat">
        <van-loading size="35" />
      </div>
      <div v-else style="width: 100%">
        <div style="width: 100%">
          <div class="tips">
            <van-icon name="warning-o" />{{ $t("tipsTop") }}
          </div>
          <div
            class="card-long"
            @click="getOrderDetail(item.id)"
            v-for="item in orderList"
          >
            <div class="left">
              <van-image
                width="1.8rem"
                height="1.8rem"
                :src="item.thumbImageUrl"
              />
            </div>
            <div class="right">
              <div class="name">{{ item.giftName }}</div>
              <div class="date">{{ $t("dhsj") }}{{ item.orderDate }}</div>
              <div class="money">{{ $t("ddzt") }}{{ item.status }}</div>
            </div>
          </div>
          <div class="finished-text" v-show="orderList.length">
            <div class="finished-text__line"></div>
            <span class="finished-text__text">{{ $t("baseline") }}</span>
          </div>
        </div>

        <div class="loading-stat" v-show="orderList.length === 0">
          <van-image width="100" height="100" :src="img" />
        </div>
      </div>
    </div>
    <div
      style="text-align: center; margin-top: 16px"
      v-if="list.length !== 0 && switchTabIndex == 1"
    >
      <!-- <van-button @click="getList(pagebar.currentPage+1)" type="primary" size="small">{{ $t("getMore") }}...</van-button>  -->
    </div>
    <div
      style="text-align: center; margin-top: 16px"
      v-if="orderList.length !== 0 && switchTabIndex == 2"
    >
      <!-- <van-button @click="getOrderList(pagebar.currentPage+1)" type="primary" size="small">{{ $t("getMore") }}...</van-button>  -->
    </div>
  </div>
</template>

  <script>
import { Gifts, Orders, accounts } from "@/api/api.js";
import { Notify } from "vant";
import jinbi from "@/assets/img/金币.png";
import img from "@/assets/img/无数据.png";
export default {
  name: "Exchange",
  components: {},
  data() {
    return {
      img: img,
      jinbi: jinbi,
      list: [],
      switchTabIndex: 1,
      orderList: [],
      pagebar: {
        currentPage: 1,
        pageSize: 15,
        totalPage: 0,
        totalSize: 0,
      },
      showLoading1: true,
      showLoading2: true,
    };
  },
  computed: {},
  methods: {
    switchTab(tabIndex) {
      this.switchTabIndex = tabIndex;
      localStorage.setItem("tabIndex", tabIndex);
      this.pagebar = {
        currentPage: 1,
        pageSize: 15,
        totalPage: 0,
        totalSize: 0,
      };
      if (tabIndex == 2) {
        this.orderList = [];
        this.getOrderList(1);
      } else {
        this.list = [];
        this.getList(1);
      }
    },
    getOrderList(currentPage) {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        page: currentPage,
        size: this.pagebar.pageSize,
      };
      Orders(params).then((res) => {
        if (res.code === 200) {
          (this.orderList = [...this.orderList, ...res.data.list]),
            //  this.orderList = [],
            (this.pagebar = res.data.pagebar);
          setTimeout(() => {
            this.showLoading1 = false;
          }, 1000);
        } else {
          setTimeout(() => {
            this.showLoading1 = false;
          }, 1000);
          Notify({ type: "warning", message: res.errors });
        }
      });
    },
    toDetail(item) {
      this.$router.push({ path: "/shopDetail", query: { id: item } });
    },
    getOrderDetail(item) {
      this.$router.push({ path: "/orderDetail", query: { id: item } });
    },
    getList(currentPage) {
      const params = {
        page: currentPage,
        size: this.pagebar.pageSize,
      };
      Gifts(params).then((res) => {
        if (res.code === 200) {
          this.list = [...this.list, ...res.data.list];
          this.pagebar = res.data.pagebar;
          setTimeout(() => {
            this.showLoading1 = false;
          }, 1000);
        } else {
          this.verifyCodeTag = false;
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },

    async getInfos() {
      const { id } = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = { id };
      const res = await accounts(params);
      if (res.code === 200) {
        this.$store.commit("setAccountInfo", res.data);
      } else {
        Notify({ type: "danger", message: res.errors[0] });
      }
    },
  },
  mounted() {
    const tabIndex = localStorage.getItem("tabIndex") || 1;
    if (tabIndex == 1) {
      this.getList(1);
      this.getInfos();
    } else {
      this.getOrderList(1);
    }
    this.switchTabIndex = tabIndex;
  },
  activated() {},
  destroyed() {
    this.switchTabIndex = 1;
    localStorage.setItem("tabIndex", 1);
  },
  beforeRouteEnter: (to, from, next) => {
    if (from.name === "OrderDetail") {
      next((vm) => {
        vm.switchTabIndex = vm.tabIndex = 2;
        localStorage.setItem("tabIndex", 2);
        vm.orderList = [];
        vm.getOrderList(1);
      });
    }
    next();
  },
};
</script>

  <style lang="stylus" scoped>
  /deep/.exchange {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #F3F3F3 !important;

    .van-grid {
      .van-grid-item {
        .van-grid-item__content {
          background-color: #A4ADB3;
          color: white;
          font-size: 0.3rem;
        }
      }
    }

    .body {
      position: relative;
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      max-height: calc(100% - 100px);
      overflow: auto;

      // justify-content: space-around;
      // padding-bottom: 1.5rem;
      .card {
        border-radius: 0.2rem;
        width: 43%;
        height: 150px;
        background: #E8E8E8;
        position: relative;
        // background: url('../../assets/img/兑换-灰.png') center center no-repeat;
        // background-size:30% 30%;
        border: 1px solid #BBBBBB;
        padding: 5px;

        .cardImg {
          border-radius: 0.2rem;
          width: 100%;
          height: 100%;
          text-align: center;
        }

        .mengban {
          height: 1rem;
          background: #BBBBBB;
          position: absolute;
          bottom: 5px;
          left: 5px;
          right: 5px;
          border-bottom-left-radius: 0.1rem;
          border-bottom-right-radius: 0.1rem;

          >div {
            margin-top: 0.15rem;
            margin-left: 0.2rem;
            color: #5E5C5C;
          }

          div.jpName {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          div.money {
            display: flex;
            align-items: center;
            color: #F67E3D;
          }
        }
      }

      .card:nth-of-type(2n+1) {
        margin-right: 20px;
        margin-bottom: 20px;
      }

      // @media screen and (min-width: 600px) {
      //   .card:nth-of-type(2n+1) {
      //     margin-right: 35px;
      //   }
      // }

      .tips {
        line-height: 14px;

        .van-icon {
          color: orange;
          margin-right: 5px;
        }
      }

      .card-long {
        margin-top: 10px;
        border-radius: 5px;
        width: 100%;
        height: 90px;
        background: #ffffff;
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;

        .left {
          margin-left: 0.2rem;
        }

        .right {
          margin-left: 0.5rem;

          .name {
            font-weight: 500;
            color: #101010 !important;
            font-size: 0.3rem;
          }

          .date {
            color: #9F9C9C;
            margin-top: 0.1rem;
            margin-bottom: 0.2rem;
            font-size: 0.26rem;
          }

          .money {
            color: #F67E3D;
            font-size: 0.26rem;
          }
        }
      }
    }

    .record {
      padding: 20px;

      .card-long :nth-child(1) {
      }
    }

    .active {
      .van-grid-item__content {
        background: #489ED7 !important;
      }
    }
  }

  .img__wrap {
    width: 100%;
    height: 100%;
    border-radius: 0.2rem;
    overflow: hidden;
  }

  /deep/ .van-image__img {
    display: inline-block;
  }

  .loading-stat {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/exchange/Exchange.vue